import { Link, Outlet } from "react-router";

import { Icon } from "@/client/components/icon";
import { ThemeSwitch } from "@/client/components/theme-switch";
import { UserAvatar } from "@/client/components/user-avatar";
import { useUser } from "@/client/services/user";

export const DashboardLayout = () => {
  const { user } = useUser();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="mx-auto max-w-7xl flex h-16 items-center justify-between px-6">
          {/* Left: Logo */}
          {/* <Link to="/" className="flex items-center">
            <Icon size={180} />
          </Link> */}
          <h1 className="text-3xl font-bold">Welcome to the Dashboard</h1>

          {/* Right: Theme Toggle & User Info */}
          <div className="flex items-center gap-3">
            <ThemeSwitch size={20} />
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium">{user?.name}</p>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </div>
            <UserAvatar size={40} />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};
